import { useNavigate } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { fmtEur, fmtMwhc, fmtDate } from "@/lib/format";
import { ArrowUpRight, Users } from "lucide-react";

const Stat = ({ label, value, testid, strong }) => (
  <div>
    <div className="eyebrow text-[10px] text-muted-foreground">{label}</div>
    <div className={`metric mt-0.5 ${strong ? "text-genis font-bold" : "font-semibold"}`} data-testid={testid}>{value}</div>
  </div>
);

const PartnerCard = ({ p, delay }) => {
  const navigate = useNavigate();
  return (
    <Card
      onClick={() => navigate(`/admin?tab=projects&partner=${p.id}`)}
      className="group p-5 cursor-pointer hover:border-genis/50 hover:-translate-y-0.5 transition-[border-color,transform] animate-fade-up"
      style={{ animationDelay: `${delay}ms` }}
      data-testid={`dashboard-partner-card-${p.id}`}
    >
      <div className="flex items-center justify-between gap-3">
        <div className="font-heading font-bold text-base truncate">{p.name}</div>
        <ArrowUpRight className="h-4 w-4 text-muted-foreground group-hover:text-genis transition-colors shrink-0" />
      </div>
      <div className="mt-4 grid grid-cols-2 gap-x-4 gap-y-3">
        <Stat label="Dossiers" value={p.projects} testid={`dashboard-partner-projects-${p.id}`} />
        <Stat label="Brouillons" value={p.drafts} testid={`dashboard-partner-drafts-${p.id}`} />
        <Stat label="Volume" value={fmtMwhc(p.total_kwhc)} testid={`dashboard-partner-kwhc-${p.id}`} />
        <Stat label="Prime" value={fmtEur(p.total_prime)} testid={`dashboard-partner-prime-${p.id}`} strong />
      </div>
      <div className="mt-4 pt-3 border-t border-border space-y-1.5">
        {p.recent.length === 0 ? (
          <div className="text-xs text-muted-foreground py-1">Aucun dossier pour le moment.</div>
        ) : p.recent.map((r) => (
          <div key={r.id} className="flex items-center justify-between gap-3 text-sm" data-testid={`dashboard-partner-recent-${r.id}`}>
            <span className="truncate">
              {r.name}
              {r.status === "brouillon" && <span className="ml-2 rounded-full border border-amber-300 bg-amber-50 px-1.5 py-0.5 text-[10px] font-semibold text-amber-700">Brouillon</span>}
            </span>
            <span className="shrink-0 text-xs text-muted-foreground">{fmtDate(r.updated_at)} · <span className="metric text-foreground">{fmtEur(r.total_prime)}</span></span>
          </div>
        ))}
      </div>
    </Card>
  );
};

export const PartnerOverview = ({ partners }) => (
  <section className="space-y-4" data-testid="dashboard-by-partner">
    <div className="flex items-center gap-2">
      <Users className="h-4 w-4 text-genis" />
      <h3 className="font-heading font-bold text-lg">Dossiers par partenaire</h3>
    </div>
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5">
      {partners.map((p, i) => <PartnerCard key={p.id} p={p} delay={i * 60} />)}
    </div>
  </section>
);
